import React from "react";
import { useLocation } from "react-router-dom";
import NavigationBar from "./NavigationBar";
import FeedbackWidget from "./FeedbackWidget";
import { PermissionOutlet } from "./PermissionRoute";
import "../styles/Layout.css";

function Layout() {
  const location = useLocation();
  const showFilterButton = location.pathname === '/dashboard';
  const handleToggleFilter = () => {
    window.dispatchEvent(new Event('toggleFilter'));
  };

  return (
    <>
      <NavigationBar
        showFilterButton={showFilterButton}
        onToggleFilter={handleToggleFilter}
      />
      <main className="app-shell-main">
        <PermissionOutlet />
      </main>
      <FeedbackWidget />
    </>
  );
}

export default Layout;
